import { FC } from 'react';
import { Box, Flex, Spinner, Text } from '@chakra-ui/react';

export const MetricModalLoading: FC = () => {
  return (
    <Box
      borderWidth="1px"
      borderRadius="md"
      overflow="hidden"
      w="100%"
      minH="600px"
      maxH="600px"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Flex direction="column" align="center" justify="center" gap={4}>
        <Spinner
          thickness="3px"
          speed="0.65s"
          emptyColor="gray.200"
          color="primary.500"
          size="lg"
        />
        <Text
          fontFamily="heading"
          fontSize="sm"
          color="text.secondary"
          fontWeight="medium"
        >
          Loading data...
        </Text>
      </Flex>
    </Box>
  );
};
